import React from 'react';
import { useTranslation } from 'react-i18next';
import { Shield, ExternalLink } from 'lucide-react';
import { Card, CardContent } from '../../ui/card';

export const SspNoService: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-[calc(100vh-7rem)] overflow-auto">
      <div className="p-6 space-y-6">
        {/* En-tête */}
        <div className="flex justify-between items-start">
          <div>
            <h1 className="text-3xl font-bold">{t('ssp.title')}</h1>
            <p className="text-muted-foreground mt-1">
              {t('ssp.subtitle')}
            </p>
          </div>
        </div>

        {/* Message principal */}
        <Card className="animate-in fade-in duration-500">
          <CardContent className="p-12">
            <div className="text-center space-y-6">
              {/* Icône avec gradient */}
              <div className="mx-auto w-24 h-24 rounded-full bg-gradient-to-br from-purple-500 to-purple-600 flex items-center justify-center">
                <Shield className="h-12 w-12 text-white" />
              </div>

              {/* Titre principal */}
              <h2 className="text-2xl font-bold text-foreground">
                {t('ssp.dashboard.noService.title')}
              </h2>

              {/* Description */}
              <p className="text-muted-foreground max-w-md mx-auto text-lg leading-relaxed">
                {t('ssp.dashboard.noService.description')}
              </p>

              {/* Bouton de contact */}
              <div className="pt-4">
                <a
                  href="mailto:georges@d-block.fr?subject=Configuration des services SSP"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-purple-500 to-purple-600 text-white rounded-lg hover:from-purple-600 hover:to-purple-700 transition-all duration-200 font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                >
                  <ExternalLink className="h-4 w-4" />
                  {t('ssp.dashboard.noService.contactButton')}
                </a>
              </div>

              {/* Note informative */}
              <p className="text-xs text-muted-foreground max-w-lg mx-auto">
                {t('ssp.dashboard.noService.note')}
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};